module.exports = function() {
  return new Worker(__webpack_public_path__ + "ec02c4200ed64c9aa04b.worker.js");
};